import axios from "axios";
import type { ViaCepResponse } from "../types";

export const lookupCep = async (cep: string): Promise<ViaCepResponse> => {
  const { data } = await axios.get<ViaCepResponse>(
    `https://viacep.com.br/ws/${cep}/json/`,
  );
  return data;
};
